import { render, staticRenderFns } from "./SpcmSessions.vue?vue&type=template&id=490be28c&scoped=true"
import script from "./SpcmSessions.vue?vue&type=script&lang=js"
export * from "./SpcmSessions.vue?vue&type=script&lang=js"
import style0 from "./SpcmSessions.vue?vue&type=style&index=0&id=490be28c&prod&lang=scss&scoped=true"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490be28c",
  null
  
)

export default component.exports